import { useState } from 'react';
import { Link } from 'react-router-dom';

const RecipesSection = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const recipeCategories = [
    {
      id: 1,
      title: 'Aniversários Sustentare',
      description: 'As comemorações dos anos que a sustentare completou.',
      icon: 'ri-cake-line',
      color: 'bg-red-500',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e07acaafa6cd67e0f21ba1aef94926d5.jpeg',
      link: 'https://www.instagram.com/sustentarealimentos/reels/'
    },
    {
      id: 2,
      title: 'Ações Sustentare',
      description: 'As ações que a Sustentare proporciona.Dentro e fora da empresa.',
      icon: 'ri-gift-line',
      color: 'bg-pink-500',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/42c4569bb653d968acb181195fa9cddb.png',
      link: 'https://www.instagram.com/sustentarealimentos/reels/'
    },
    {
      id: 3,
      title: 'Nosso Natal',
      description: 'As comemorações dos natais que a Sustentare comemorou.',
      icon: 'ri-gift-2-line',
      color: 'bg-blue-500',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/30bb90e154b4aa53624a9aa7d1a1b957.jpeg',
      link: 'https://www.instagram.com/sustentarealimentos/reels/'
    }
  ];

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Redirect to recipes page with search term
    window.location.href = `/receitas?search=${encodeURIComponent(searchTerm)}`;
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Pessoas & Cultura
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            São as pessoas que garantem a qualidade, a segurança e a confiança em cada produto que entregamos.
          </p>
        </div>

        {/* Recipe Categories */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {recipeCategories.map((category) => (
            <div key={category.id} className="group cursor-pointer">
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
                {/* Image */}
                <div className="aspect-video overflow-hidden">
                  <img 
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                
                {/* Content */}
                <div className="p-8">
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 ${category.color} rounded-full flex items-center justify-center mr-4`}>
                      <i className={`${category.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500 block">Sustentare</span>
                      <h3 className="text-2xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                        {category.title}
                      </h3>
                    </div>
                  </div>
                  
                  <p className="text-gray-600 mb-6">
                    {category.description}
                  </p>
                  
                  <a 
                    href={category.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors whitespace-nowrap"
                  >
                    Ver mais...
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA removed */}
      </div>
    </section>
  );
};

export default RecipesSection;
